
import React from "react";
import { Navigate } from "react-router-dom";

const UserGuard = ({ children, allowedRoles }) => {
  const user = JSON.parse(localStorage.getItem('user_cred'));
  if (!user || !user.token || user.roleType !== "user") {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default UserGuard;